var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetricsLightmode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6502 61.9385C45.2921 60.9895 44.9605 59.1192 45.9096 57.7611L60.1552 37.3756C61.1042 36.0175 62.9746 35.6859 64.3327 36.635C65.6908 37.584 66.0224 39.4544 65.0733 40.8125L50.8277 61.1979C49.8787 62.556 48.0083 62.8876 46.6502 61.9385Z",
    fill: "#FC3165"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 55C32.3431 55 31 53.6569 31 52C31 50.3431 32.3431 49 34 49C35.6569 49 37 50.3431 37 52C37 53.6569 35.6569 55 34 55Z",
    fill: "#000433"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55C64.3431 55 63 53.6569 63 52C63 50.3431 64.3431 49 66 49C67.6569 49 69 50.3431 69 52C69 53.6569 67.6569 55 66 55Z",
    fill: "#000433"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43C36.3431 43 35 41.6569 35 40C35 38.3431 36.3431 37 38 37C39.6569 37 41 38.3431 41 40C41 41.6569 39.6569 43 38 43Z",
    fill: "#000433"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 37C48.3431 37 47 35.6569 47 34C47 32.3431 48.3431 31 50 31C51.6569 31 53 32.3431 53 34C53 35.6569 51.6569 37 50 37Z",
    fill: "#000433"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63C46.6863 63 44 60.3137 44 57C44 53.6863 46.6863 51 50 51C53.3137 51 56 53.6863 56 57C56 60.3137 53.3137 63 50 63Z",
    fill: "#FC3165"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 79.0769C66.0587 79.0769 79.0769 66.0587 79.0769 50C79.0769 33.9413 66.0587 20.9231 50 20.9231C33.9413 20.9231 20.9231 33.9413 20.9231 50C20.9231 66.0587 33.9413 79.0769 50 79.0769ZM50 86C69.8822 86 86 69.8822 86 50C86 30.1177 69.8822 14 50 14C30.1177 14 14 30.1177 14 50C14 69.8822 30.1177 86 50 86Z",
    fill: "#000433"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetricsLightmode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/metrics-lightmode.b3fa6fd696b886df88a85c59845f2472.svg";